import { Box, IconButton } from '@mui/material';
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number,
  ) => void;
}

export default function TablePaginationActions(
  props: Readonly<TablePaginationActionsProps>,
) {
  const { count, page, rowsPerPage, onPageChange } = props;
  const totalPages = Math.ceil(count / rowsPerPage);

  const handleFirstPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        ml: 0,
      }}
    >
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0 || totalPages <= 1}
        aria-label="first page"
        size="small"
        sx={{ p: 0.5 }}
      >
        <FirstPageIcon fontSize="small" />
      </IconButton>

      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0 || totalPages <= 1}
        aria-label="previous page"
        size="small"
        sx={{ p: 0.5 }}
      >
        <KeyboardArrowLeft fontSize="small" />
      </IconButton>

      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= totalPages - 1 || totalPages <= 1}
        aria-label="next page"
        size="small"
        sx={{ p: 0.5 }}
      >
        <KeyboardArrowRight fontSize="small" />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= totalPages - 1 || totalPages <= 1}
        aria-label="last page"
        size="small"
        sx={{ p: 0.5 }}
      >
        <LastPageIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
